// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountRelationModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountRelationModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountRelationModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountRelationModel.attributeTypeMap = [
    {
        "name": "relatedId",
        "baseName": "relatedId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountRelationModel.js.map